import axios from 'lib/axios';

import {
  ORDER_ERROR,
  ORDER_UPDATE,
  ORDER_DELETE,
  ORDERS_ERROR,
  ORDER_LOADING,
  ORDER_CREATED,
  ORDER_UPDATED,
  ORDER_RECEIVED,
  ORDERS_LOADING,
  ORDERS_RECEIVED,
  ADDRESS_LOADING,
  ORDER_SET_ACTIVE,
  ADDRESSES_CLEAR,
  ADDRESSES_SET_PAGE,
  ADDRESSES_NEXT_PAGE,
  ADDRESSES_RECEIVED,
  ORDER_UPLOAD_LOADING,
  ADDRESS_LOOKUP_CLEAR,
  ADDRESS_SEARCH_ERROR,
  ADDRESS_PAGE_LOADING,
  ORDER_UPDATE_LOADING,
  ORDER_ITEMS_LOADING,
  ORDER_ITEMS_RECEIVED,
  ADDRESS_SEARCH_LOADING,
  ORDER_DOCUMENT_RECEIVED,
  ADDRESS_SEARCH_RECEIVED,
  CHECKOUT_LOADING,
  ORDER_CHECKOUT_RECEIVED,
  ADDRESS_SUGGESTION_ERROR
} from 'constants/actions';

import { dispatchSetMessage } from './messages';

import {
  E_ORDER_PAYMENT,
  E_ORDER_UNKNOWN,
  E_ORDERS_UNKNOWN,
  E_ORDER_NOT_FOUND,
  E_ORDERS_NOT_FOUND,
  E_ADDRESSES_UNKNOWN,
  E_ADDRESSES_NOT_FOUND,
  E_ORDER_UPDATE_UNKNOWN,
  E_ORDER_UPLOAD_UNKNOWN,
  E_ORDER_CREATE_UNKNOWN,
  E_ADDRESS_SEARCH_UNKNOWN,
  E_ADDRESS_SEARCH_NOT_FOUND,
  E_ORDER_ITEMS_UNKNOWN
} from 'constants/errors';

import { M_ORDER_CREATED, M_DOCUMENT_UPLOAD, M_ORDER_UPDATED, M_ORDER_UPDATE_REQUESTED } from 'constants/messages';

import { dispatcher } from 'lib/redux';

const COUNCIL_SEARCH = 'COUNCIL_SEARCH'; //temp move to constants
const FORM1 = 'FORM1';

export const clearAddressSuggestions = () => () => {
  dispatcher(ADDRESSES_CLEAR);
};

export const setActive = (orderId) => () => {
  dispatcher(ORDER_SET_ACTIVE, orderId);
};

export const updateOrder = (data) => () => {
  dispatcher(ORDER_UPDATE, data);
};

export const addressesNextPage = () => () => {
  dispatcher(ADDRESSES_NEXT_PAGE);
};

export const addressesResetPage = () => () => {
  dispatcher(ADDRESSES_SET_PAGE, 1);
};

export const deleteOrder = () => () => {
  dispatcher(ORDER_DELETE);
};

export const getItems = (type = FORM1) => async (dispatch) => {
  try {
    var response = await axios.get(`items?type=${type}`);

    dispatcher(ORDER_ITEMS_LOADING, false);
    dispatcher(ORDER_ITEMS_RECEIVED, response.data);
  } catch (e) {
    dispatcher(ORDER_ITEMS_LOADING, false);

    if (e.canceled) return;

    dispatcher(ORDER_ERROR, E_ORDER_ITEMS_UNKNOWN);
  }
};

export const uploadDocument = (file, description) => async (dispatch, getState) => {
  dispatcher(ORDER_UPLOAD_LOADING, true);

  const data = new FormData();

  data.append('document', file);
  data.append('description', description);
  data.append('fileName', file.name || 'New Document');

  try {
    const opts = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };

    const response = await axios.post(
      `orders/${getState().orders.activeOrder}/documents`, data, opts
    );

    dispatcher(ORDER_UPLOAD_LOADING, false);
    dispatcher(ORDER_DOCUMENT_RECEIVED, response.data);
    dispatchSetMessage(M_DOCUMENT_UPLOAD);
  } catch (e) {
    dispatcher(ORDER_UPLOAD_LOADING, false);

    if (e.canceled) return;

    try {
      dispatcher(ORDER_ERROR, e.response.data.message || E_ORDER_UPLOAD_UNKNOWN);
    } catch (e) {
      dispatcher(ORDER_ERROR, E_ORDER_UPLOAD_UNKNOWN);
    }
  }
};

export const updateActiveOrder = (values) => async (dispatch, getState) => {
  dispatcher(ORDER_UPDATE_LOADING, true);

  try {
    var response = await axios.put(
      `orders/${getState().orders.activeOrder}`,
      values
    );

    dispatcher(ORDER_UPDATE_LOADING, false);
    dispatcher(ORDER_UPDATED);
    dispatchSetMessage(M_ORDER_UPDATED);
    dispatcher(ORDER_RECEIVED, response.data);
  } catch (e) {
    dispatcher(ORDER_UPDATE_LOADING, false);

    if (e.canceled) return;

    dispatcher(ORDER_ERROR, E_ORDER_UPDATE_UNKNOWN);
  }
};

export const requestUpdatedCertificate = (orderId, itemId) => async () => {
  dispatcher(ORDER_UPDATE_LOADING, true);

  try {
    var response = await axios.put(`orders/${orderId}/update`, { item_id: itemId });

    dispatcher(ORDER_UPDATE_LOADING, false);
    dispatcher(ORDER_RECEIVED, response.data);
    dispatchSetMessage(M_ORDER_UPDATE_REQUESTED);
    dispatcher(ORDER_UPDATED);
  } catch (e) {
    dispatcher(ORDER_UPDATE_LOADING, false);

    if (e.canceled) return false;

    if (e.response && e.response.status === 404) {
      return dispatcher(ORDER_ERROR, E_ORDER_NOT_FOUND);
    }

    dispatcher(ORDER_ERROR, E_ORDER_UNKNOWN);
  }
};

export const getCheckout = (type) => async (dispatch, getState) => {
  const order = getState().pendingOrder.pending;

  dispatcher(CHECKOUT_LOADING, false);

  try {
    var response = await axios.post(`orders/checkout`, mapCheckout(order, type));

    dispatcher(CHECKOUT_LOADING, false);
    dispatcher(ORDER_CHECKOUT_RECEIVED, response.data);
  } catch (e) {
    dispatcher(CHECKOUT_LOADING, false);

    if (e.canceled) return;

    if (e.response && e.response.data) {
      return dispatcher(ORDER_ERROR, e.response.data.message || E_ORDER_UNKNOWN);
    }

    dispatcher(ORDER_ERROR, E_ORDER_UNKNOWN);
  }
};

export const submitOrder = (type) => async (dispatch, getState) => {
  const order = getState().pendingOrder.pending;

  dispatcher(ORDER_LOADING, true);

  try {
    const opts = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } };
    var response = await axios.post('orders', mapSubmit(order, type), opts);

    dispatchSetMessage(M_ORDER_CREATED);
    dispatcher(ORDER_LOADING, false);
    dispatcher(ORDER_CREATED, response.data.id);
    dispatcher(ORDER_RECEIVED, response.data);
  } catch (e) {
    dispatcher(ORDER_LOADING, false);

    if (e.canceled) return;

    if (e.response && e.response.data) {
      return e.response.data.stripeError
        ? dispatcher(ORDER_ERROR, E_ORDER_PAYMENT + e.response.data.message)
        : dispatcher(ORDER_ERROR, e.response.data.message || E_ORDER_CREATE_UNKNOWN);
    }

    dispatcher(ORDER_ERROR, E_ORDER_CREATE_UNKNOWN);
  }
};

export const fetchOrders = () => async () => {
  dispatcher(ORDERS_LOADING, true);

  try {
    var response = await axios.get('orders');

    dispatcher(ORDERS_LOADING, false);
    dispatcher(ORDERS_RECEIVED, response.data);
  } catch (e) {
    dispatcher(ORDERS_LOADING, false);

    if (e.canceled) return;

    if (e.response && e.response.status === 404) {
      return dispatcher(ORDERS_ERROR, E_ORDERS_NOT_FOUND);
    }

    dispatcher(ORDERS_ERROR, E_ORDERS_UNKNOWN);
  }
};

export const fetchOrder = (orderId) => async () => {
  dispatcher(ORDER_LOADING, true);

  try {
    var response = await axios.get(`orders/${orderId}`);

    dispatcher(ORDER_LOADING, false);
    dispatcher(ORDER_RECEIVED, response.data);
  } catch (e) {
    dispatcher(ORDER_LOADING, false);

    if (e.canceled) return false;

    if (e.response && e.response.status === 404) {
      return dispatcher(ORDER_ERROR, E_ORDER_NOT_FOUND);
    }

    dispatcher(ORDER_ERROR, E_ORDER_UNKNOWN);
  }
};

export const fetchAddressSuggestions = (query) => async () => {
  dispatcher(ADDRESS_LOADING, true);

  try {
    var response = await axios.get(`orders/autocomplete?query=${query}`);

    dispatcher(ADDRESS_LOADING, false);
    dispatcher(ADDRESSES_RECEIVED, {
      council_addresses: response.data,
      council_addresses_query: query,
      council_addresses_updated: Date.now()
    });
  } catch (e) {
    dispatcher(ADDRESS_LOADING, false);

    if (e.canceled) return;

    if (e.response && e.response.status === 404) {
      return dispatcher(ADDRESS_SUGGESTION_ERROR, E_ADDRESSES_NOT_FOUND);
    }

    dispatcher(ADDRESS_SUGGESTION_ERROR, E_ADDRESSES_UNKNOWN);
  }
};

export const addressSearch = (reset = true) => async (dispatch, getState) => {
  const state = getState().pendingOrder;
  const order = state.pending;

  if (reset) {
    dispatcher(ADDRESS_SEARCH_LOADING, true);
    dispatcher(ADDRESS_LOOKUP_CLEAR);
  } else {
    dispatcher(ADDRESS_PAGE_LOADING, true);
  }

  try {
    var response = await axios.post('lookup/address', {
      page: state.addressesPage,
      lot_no: order.address_lot || '',
      state: order.address_state || '',
      unit_no: order.address_unit || '',
      suburb: order.address_suburb || '',
      street: order.address_street_1 || '',
      street_no: order.address_street_no || ''
    });


    dispatcher(ADDRESS_SEARCH_LOADING, false);
    dispatcher(ADDRESS_PAGE_LOADING, false);

    if (response.data && response.data.length) {
      dispatcher(ADDRESS_SEARCH_RECEIVED, response.data);
    } else {
      dispatcher(ADDRESS_SEARCH_ERROR, E_ADDRESS_SEARCH_NOT_FOUND);
    }
  } catch (e) {
    dispatcher(ADDRESS_SEARCH_LOADING, false);
    dispatcher(ADDRESS_PAGE_LOADING, false);

    if (e.canceled) return;

    dispatcher(ADDRESS_SEARCH_ERROR, E_ADDRESS_SEARCH_UNKNOWN);
  }
};

const mapAddress = (formData, order) => {
  formData.append(
    'address_street_1',
    `${order.address_street_no || ''} ${order.address_street_1}`
  );

  if (order.address_unit) {
    formData.append('address_unit', order.address_unit);
  }

  if (order.address_lot) {
    formData.append('address_lot', order.address_lot);
  }

  if (order.address_street_2) {
    formData.append('address_street_2', order.address_street_2);
  }

  formData.append('address_state', order.address_state);
  formData.append('address_suburb', order.address_suburb);
  formData.append('address_postcode', order.address_postcode);
};

const mapGlobalx = (formData, order) => {
  if (!order.globalx_meta) {
    formData.append('address_plan_lot_section', order.address_plan_lot_section);
    formData.append('address_ct', order.address_ct);
  } else {
    formData.append('globalx_meta', JSON.stringify(order.globalx_meta));
  }

  if (order.uploaded_title) {
    formData.append('uploaded_title', true);
    formData.append('title_order_id', order.createFrom.id)
  }else if (order.upload_title) {
    formData.append('upload_title', true);
    formData.append('title', order.title);
  } else if (order.order_title) {
    formData.append('order_title', true);
  }
};

const mapStrata = (formData, order) => {
  if (!order.selected_strata) return false;

  if (order.selected_strata_cert) {
    formData.append('strata_id', order.selected_strata);
    formData.append('strata_item_id', order.selected_strata_cert);
  }

  if (order.strata_other) {
    formData.append('strata_name', order.strata_name);
  }
};

//TODO refactor mapSubmit to make this less jank
const mapCheckout = (order, type) => {
  const data = {
    ...Object.fromEntries(mapSubmit(order, type)),
    'item_ids[]': undefined,
    title: undefined,
    proposed_settlement_date: undefined
  };

  if (type === COUNCIL_SEARCH) {
    data.item_ids = [ order.selected_certificate ];
  }

  if (order.globalx_meta) {
    data.globalx_meta = order.globalx_meta
  }

  return data;
}

const mapSubmit = (order, type) => {
  var submit = new FormData();

  submit.append('type', type);

  if (order.additional_information) {
    submit.append('additional_information', order.additional_information);
  }

  if (type !== FORM1 && order.selected_strata_cert) {
    submit.append('proposed_settlement_date', order.proposed_settlement_date || '');
  }

  if (type === COUNCIL_SEARCH) {
    submit.append('council_id', order.selected_council_id);
    submit.append('item_ids[]', order.selected_certificate);
  }

  if (order.file_number) {
    submit.append('file_number', order.file_number);
  }

  mapAddress(submit, order);
  mapGlobalx(submit, order);
  mapStrata(submit, order);

  return submit;
};
